import React, { useState } from 'react'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'

interface ScreenShellProps {
	children: React.ReactNode
}

/**
 * Provides the standard CN layout shell (AdminPanelCN sidebar + HeaderCN header)
 * for screens that haven't been fully migrated to the CN pattern yet.
 */
const ScreenShell = ({ children }: ScreenShellProps) => {
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />
			<div className="flex-1 flex flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />
				<div className="flex-1 overflow-y-auto">
					{children}
				</div>
			</div>
		</div>
	)
}

export default ScreenShell
